var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.928,
    height: 30.929,
    viewBox: "0 0 30.928 30.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "warning_pink_svg__Icon_metro-warning",
    "data-name": "Icon metro-warning",
    d: "M18.035,4.73l12.96,25.831H5.074L18.035,4.73Zm0-2.8A2.235,2.235,0,0,0,16.2,3.277L2.995,29.587c-1.011,1.8-.151,3.269,1.912,3.269H31.163c2.063,0,2.923-1.471,1.912-3.269h0L19.874,3.277A2.235,2.235,0,0,0,18.035,1.928Zm1.933,25.129a1.933,1.933,0,1,1-1.933-1.933A1.933,1.933,0,0,1,19.968,27.058Zm-1.933-3.866A1.933,1.933,0,0,1,16.1,21.258v-5.8a1.933,1.933,0,1,1,3.866,0v5.8A1.933,1.933,0,0,1,18.035,23.191Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#f03737"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningPink);
export default __webpack_public_path__ + "static/media/warning_pink.51d23a2895a81b6d92582de4fbe87aaf.svg";
export { ForwardRef as ReactComponent };